export const _31DaysMonths = [1, 3, 5, 7, 8, 10, 12];
export const _sortingByNumber = ["seatingCapacity", "floor"];
export const _daysOfWeek = [
  {
    value: 0,
    label: "Sunday",
  },
  {
    value: 1,
    label: "Monday",
  },
  {
    value: 2,
    label: "Tuesday",
  },
  {
    value: 3,
    label: "Wednesday",
  },
  {
    value: 4,
    label: "Thursday",
  },
  {
    value: 5,
    label: "Friday",
  },
  {
    value: 6,
    label: "Saturday",
  },
];
export const _dayOfWeek={
    "Sunday":0,
    "Monday":1,
    "Tuesday":2,
    "Wednesday":3,
    "Thursday":4,
    "Friday":5,
    "Saturday":6
}
export const _concurrencyOptions=[
  {
    value:1,
    label:"Once"
  },
]

/** Maximum days in advance a room can be booked (0 = today only) */
export const MAX_BOOKING_ADVANCE_DAYS = 0;

/** Admins may book future dates / recurring bookings up to this many days ahead */
export const ADMIN_MAX_BOOKING_ADVANCE_DAYS = 60;

/** Maximum total booking duration per user per day without exception (hours) */
export const MAX_DAILY_BOOKING_HOURS = 2;

/** Hard maximum with a monthly exception (hours) */
export const MAX_EXCEPTION_DAILY_BOOKING_HOURS = 4;

/** Monthly exception allowance per user */
export const MONTHLY_EXCEPTION_LIMIT = 2;

/** Monthly admin room-release allowance per admin */
export const MONTHLY_ADMIN_RELEASE_LIMIT = 4;

/** Allowed admin release reasons */
export const ADMIN_RELEASE_REASONS = [
  { value: "No-show", label: "No-show" },
  { value: "Urgent client need", label: "Urgent client meeting" },
];
// export const emp_code = "SPAN-BLR-2027";
